module.exports = __webpack_public_path__ + "img/ad1.f807c241.jpg";